if (typeof LazyLoad === 'undefined') {
	(function (w, d) {
		var b = d.getElementsByTagName('head')[0];
		var s = d.createElement("script");
		var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.19.0";
		s.setAttribute('defer', '');
		s.src = (typeof window.lazyLoadPath === 'string' ? window.lazyLoadPath : "/DesktopModules/PanteraModuleGlobal/lazyload/js") + ("/lazyload-" + v + ".min.js");
		b.appendChild(s);
	}(window, document));
}